import React from 'react';
import { BarChart3Icon } from 'lucide-react';
const metrics = [{
  label: 'Devices Processed',
  value: '10M+',
  description: 'Devices assessed and traded'
}, {
  label: 'Accuracy Rate',
  value: '99.8%',
  description: 'AI-powered assessment accuracy'
}, {
  label: 'Secure Data Wiping',
  value: '100%',
  description: 'Data security compliance'
}, {
  label: 'Value Returned',
  value: '$500M+',
  description: 'Total value back to customers'
}];
export function DeviceMetrics() {
  return <section className="bg-gray-50 dark:bg-black py-20" data-id="element-392">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-393">
        <div className="text-center mb-16" data-id="element-394">
          <div className="inline-flex items-center px-4 py-1 bg-blue-100 dark:bg-brand-green/10 text-blue-600 dark:text-brand-green rounded-full text-sm font-medium mb-4" data-id="element-395">
            <BarChart3Icon className="h-4 w-4 mr-2" data-id="element-396" />
            DEVICE ANALYTICS
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-397">
            Real-time performance metrics
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto" data-id="element-398">
            Live Data
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-399">
          {metrics.map((metric, index) => <div key={index} className="bg-white dark:bg-gray-900 rounded-xl p-8 border border-gray-200 dark:border-gray-800 text-center group hover:border-blue-500 dark:hover:border-brand-green transition-colors" data-id="element-400">
              <div className="text-4xl sm:text-5xl font-bold mb-4 bg-gradient-to-r from-blue-600 to-blue-400 dark:from-brand-green dark:to-brand-green/60 bg-clip-text text-transparent group-hover:scale-110 transition-transform" data-id="element-401">
                {metric.value}
              </div>
              <div className="text-lg font-medium text-gray-900 dark:text-white mb-2" data-id="element-402">
                {metric.label}
              </div>
              <div className="text-sm text-gray-600 dark:text-gray-400" data-id="element-403">
                {metric.description}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}